import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import bodaccReducer from './slices/bodaccSlice';
import dashboardReducer from './slices/dashboardSlice';
import nouveauxAdherentsReducer from './slices/nouveauxAdherentsSlice';
import surveillanceReducer from './slices/surveillanceSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    bodacc: bodaccReducer,
    nouveauxAdherents: nouveauxAdherentsReducer,
    dashboard: dashboardReducer,
    surveillance: surveillanceReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 